import axios from 'axios';

export const getWeeklyWinners = (year, week) => {
     return axios
      .get(process.env.REACT_APP_BASE_API + 'week_leaders', { params: { year: year, week: week } })
      .then((res) => {
        return res.data
      })

  };


export const getSeasonWinners = (year) => {
  return axios
    .get(process.env.REACT_APP_BASE_API + 'season_leaders', { params: { year: year } })
    .then((res) => {
      return res.data
    })

};

export const getSeasonWinnersThroughWeek = (year, week) => {
  return axios
    .get(process.env.REACT_APP_BASE_API + 'season_leaders', { params: { year: year, week: week } })
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSeasonInsights = (year, week) => {
  return axios
    .get(process.env.REACT_APP_BASE_API + 'season_insights', { params: { year, week } })
    .then((res) => res.data);
};

export const getWeekRecap = (year, week) => {
  return axios
    .get(process.env.REACT_APP_BASE_API + 'week_recap', { params: { year, week } })
    .then((res) => res.data);
};

export const getPlayoffRace = (year, week) => {
  return axios
    .get(process.env.REACT_APP_BASE_API + 'playoff_race', { params: { year, week } })
    .then((res) => res.data);
};

export const getStandings = (year) => {
  return axios
    .get(process.env.REACT_APP_BASE_API + 'standings', { params: { year: year} })
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      console.log(err);
    });
};
